export const debug = false;
export const customFont = 'custom';
export const userFont = 'user';
export const googleFont = 'google';
